import { DialogSectionCss } from '@PagesComponent/ActiveSmartShip/ActiveStyleComp'
import React, { useState } from 'react'
import DialogComponent from './DialogComponent'

const LoginPopup = ({ openLoginPopup, setOpenLoginPopup }) => {

    return (
        <>
            {/* <DialogComponent opend={openLoginPopup} handleClose={() => setOpenLoginPopup(false)} title="Welcome to Kaire’s New Website!">
                <DialogSectionCss>
                    <div className='login-pop'>
                        Welcome to Kaire’s New Website.If you have not logged into our new site yet, please Click 'Forgot Password' and enter your Email or Mobile number to Reset your Password.
                        <br />
                        <br />

                        <b> For Email Reset: </b> Check for an email and click Reset my Password.  Enter your Personal Password and confirm it and click to Reset. (Please check your Spam folder as well)
                        <br />
                        <br />

                        <b> For Text Reset: </b> Check your mobile phone for a 4 digit OTP (One Time Password) enter and click OTP Verify then enter your Personal Password and confirm it and click to Reset. <br />

                        <br />

                        With Kaire…. Live Better Longer!
                    </div>
                </DialogSectionCss>
            </DialogComponent> */}
        </>
    )
}

export default LoginPopup